import EnergyCard from './EnergyCard';

export default EnergyCard;
